import { IMPROVE_CONFIG } from "@/config.js";

const token = localStorage.getItem("token");

const AWSS3Config = {
  signingURL: IMPROVE_CONFIG.API_URL + "/sign",
  headers: {
    'Authorization': 'Bearer ' + token,
    "Accept": "application/json",
    'Access-Control-Allow-Origin': '*'
    //"Cache-Control": "no-cache, private",
    //"Content-Type": "application/json"
  },
  params: {},
  sendFileToServer: false,
  withCredentials: false
};

export default AWSS3Config;